export const Colors = {
  primary: "#151D30",
  darkPrimary: "#1A1824",
  accent: "#F86F6F",
  white: "#fff",
  whiteGrey: "#848484",
  grey: "#848484",
  black: "#000000",
  inputGrey: "#EBEBEB",
};
